import type { ComponentType } from "react";

import LayoutDefault from "src/pages/RundownDetail/Layouts/Default";
import LayoutMatchControl from "src/pages/RundownDetail/Layouts/MatchControl";
import LayoutNrcsOperator from "src/pages/RundownDetail/Layouts/NrcsOperator";
import LayoutPlaylist from "src/pages/RundownDetail/Layouts/Playlist";
import LayoutQuickControl from "src/pages/RundownDetail/Layouts/QuickControl";
import LayoutSimplified from "src/pages/RundownDetail/Layouts/Simplified";

export type LayoutDefinition = {
	key: string;
	label: string;
	beta: boolean;
	component: ComponentType;
};

export const LAYOUTS: LayoutDefinition[] = [
	{ key: "default", label: "Default layout", beta: false, component: LayoutDefault },
	{ key: "simplified", label: "Simplified layout", beta: false, component: LayoutSimplified },
	{
		key: "matchcontrol",
		label: "Match control layout",
		beta: false,
		component: LayoutMatchControl,
	},
	{
		key: "quickcontrol",
		label: "Quick control layout",
		beta: false,
		component: LayoutQuickControl,
	},
	{ key: "playlist", label: "Playlist layout", beta: false, component: LayoutPlaylist },
	{ key: "nrcs", label: "NRCS Operator layout", beta: false, component: LayoutNrcsOperator },
];
